<script setup>
import { ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker, MarkerCluster } from "vue3-google-map";
import helpers from '@/Common/helpers';
import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiCableData,
    mdiCctv,
    mdiSend,
    mdiEmailFast

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    services: Object,
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)

const companyInfo = ref(null)
companyInfo.value = [
    { 'id': '500', 'info': 'Empresa Peruana con más de 10 años... Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium unde aut itaque accusamus dolores rerum, quas in quos nostrum incidunt vero assumenda id fugit veritatis?', 'mision': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas unde soluta voluptates ex quo dolore, tempore odio impedit accusantium explicabo minus error, exercitationem porro nesciunt, similique quibusdam iure nihil iste.', 'imagen_mision': '/img/empresa/informacion/02.jpg', 'vision': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas unde soluta voluptates ex quo dolore, tempore odio impedit accusantium explicabo minus error, exercitationem porro nesciunt, similique quibusdam iure nihil iste.', 'imagen_vision': '/img/empresa/informacion/02.jpg' }
]

// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const servicios = ref(null)
servicios.value = [
    { 'id': '101', 'label': 'Cableado Estructurado', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/01.jpg' },
    { 'id': '102', 'label': 'Sistemas CCTV y video vigilancia IP', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/02.jpg' },
    { 'id': '103', 'label': 'certificación de puntos de red', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/03.jpg' },
    { 'id': '104', 'label': 'sistemas de alarma contra incendio', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/04.jpg' },
    { 'id': '105', 'label': 'sistemas de perifoneo y sonido', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/05.jpg' },
    { 'id': '106', 'label': 'fusión de fibras ópticas', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/06.jpg' },
]


// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

const urlNow = ref(window.location.origin)

</script>

<template>
    <SeoMeta />
    <!-- Meta general de servicios -->
    <!-- <Head>
        <title>{{ object ? object.label : 'Category' }}</title>
        <meta name="description" :content="object ? object.description : 'Category Description'">

        <meta property="og:type" content="website">
        <meta property="og:url" :content="urlNow+'/ecommerce/product/card?id='+object.id">
        <meta property="og:title" :content="object.label + ' - ' + urlNow">
        <meta property="og:description" :content="object.description">
        <meta property="og:image" :content="(object.files[0] ? urlNow + '/documents/' + object.files[0].filepath + '/' + object.files[0].filename : '')">
        <meta property="og:image:alt" :content="object.label">
        <meta property="og:site_name" :content="urlNow">
        <link rel="canonical" :href="urlNow+'/ecommerce/product/card?id='+object.id">
    </Head> -->

    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">


        <!-- Modal -->
        <CardBoxModal v-model="isModalActive" title="Matrícula en línea">
            <p>Información del <b>padre de familia / apoderado</b></p>
            <!--<p>This is sample modal</p>-->
            <div>
                <BreezeLabel for="nombre" value="Nombre" />
                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.nombre" required autofocus autocomplete="name" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="nivel" value="Nivel escolar" />
                <BreezeInput id="inicial" type="checkbox" class="mt-1 ml-2" v-model="form.inicial" required autocomplete="inicial" /> Inicial
                <BreezeInput id="primaria" type="checkbox" class="mt-1 ml-2" v-model="form.primaria" required autocomplete="primaria" /> Primaria
                <BreezeInput id="secundaria" type="checkbox" class="mt-1 ml-2" v-model="form.secundaria" required autocomplete="secundaria" /> Secundaria
            </div>
            <div class="mt-4">
                <BreezeLabel for="phone" value="Teléfono" />
                <BreezeInput id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" required autocomplete="phone" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="email" value="Email" />
                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="mail" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="comment" value="Comentario" />
                <BreezeInput id="comment" type="text" class="mt-1 block w-full" v-model="form.comment" required autocomplete="comment" />
            </div>
            <!--<div class="block mt-4">
                <label class="flex items-center">
                    <BreezeCheckbox name="remember" v-model:checked="form.recibirinfo" />
                    <span class="ml-2 text-sm text-gray-600">Recibir novedades?</span>
                </label>
            </div>-->
        </CardBoxModal>



        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/servicios/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Servicios que ofrecemos</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Servicios</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>

            <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div class="grid grid-cols-1 xl:grid-cols-5 gap-16">
                    <div class="xl:col-span-2">
                        <div v-html="confGlobal.value.SERVICES_CONTENT_INTRODUCTION_PAGE" class="mb-8"></div>
                        <div>
                            <Link :href="route('eco-contactinfo')">
                                <button type="button" class="btn btn-color px-8 btn-ico">
                                    <BaseIcon :path="mdiEmailFast" :size="20" class="mr-2" /> Contactanos
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div class="xl:col-span-3">
                        <div class="flex items-center w-full h-full">
                            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 w-full gap-3 " v-if="services.length > 0">
                                <div class="col-span-1 flex border items-center rounded-md" v-for="(item, index) in services" :key="item.id">
                                    <div class="w-16 p-2 shrink-0">
                                        <BaseIcon :path="mdiCableData" :size="40" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                                    </div>
                                    <div class="p-2">
                                        <p class="font-semibold text-base">{{ item.label }}</p>
                                        <!-- <span class="text-gray-600">{{ item.description }}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="mx-auto px-4 sm:px-6">
            <hr class=" my-6">
        </div>
        <section>
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1" v-if="services.length > 0">
                    <!-- Imagen en izquierda en pc debe ser divs lg:order-2 lg:order-1 -->
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 py-12" v-for="(item, index) in services" :key="item.id">
                        <div class="flex items-center order-1" :class="index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'">
                            <div class="py-8">
                                <div class="mb-5">
                                    <div class="bg-color rounded-md w-16 h-16 flex items-center justify-center mb-4 shadow-md">
                                        <BaseIcon :path="mdiCableData" :size="50" w="w-10" h="h-10" class="text-white"></BaseIcon>
                                    </div>
                                    <h1 class="mb-4">{{ item.label }}</h1>
                                    <div>
                                        <div v-if="item.public_note" v-html="item.public_note" class="prose max-w-none"></div>
                                        <div v-else v-html="item.description" class="prose max-w-none"></div>
                                    </div>
                                </div>
                                <div>
                                    <Link :href="route('eco-contactinfo')">
                                        <button type="button" class="btn btn-color px-8 btn-ico">
                                            <BaseIcon :path="mdiSend" :size="20" class="mr-2" /> Solicitar servicio
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div class="h-full order-2" :class="index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'">
                            <div class="h-full bg-no-repeat bg-center bg-cover min-h-[300px] lg:min-h-[400px]" :style="'background: url(' + (item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '') + ') center center no-repeat; background-size: cover;'"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div aria-hidden="true" class="mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 bg-color mt-12">
                <div class="grid grid-cols-5">
                    <div class="col-span-3">
                        <h1 class="text-white text-[2.1em] mb-2">¿Tiene consultas? Podemos responderlas todas.</h1>
                        <p class="text-white text-lg">Llámenos ahora al <a :href="'tel:' + confGlobal.value.COMPANY_PHONE" class="font-semibold">{{ helpers.number2Phone(confGlobal.value.COMPANY_PHONE, 'fijo') }}</a> o
                            escribanos a <a class="font-semibold" :href="'mailto:' + confGlobal.value.COMPANY_MAIL" href="#">{{ confGlobal.value.COMPANY_MAIL }}</a>.<br>
                            Podemos resolver esa consulta con una sola llamada, si es una consulta muy amplia agende ahora una reunión.</p>
                    </div>
                    <div class="col-span-2 flex items-center justify-center">
                        <Link type="button" class="btn btn-ico btn-lg space-x-3 btn-light" :href="route('eco-contactinfo')">
                            <BaseIcon :path="mdiSend" :size="24" class="!text-red" w="w-4" h="h-4"></BaseIcon>
                            <span>Obtener más información</span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
